export function setAll(state, action) {
    return action.data
}

export function setInMemory(state, action, index, section = null, value = null) {
    let newState = state

    if (value) {
        newState = {
            ...state,
            [index]: {
                ...state[index],
                [section]: {
                    ...state[index][section],
                    [value]: action.data
                }
            }
        }
    } else if (!value && section) {
        newState = {
            ...state,
            [index]: {
                ...state[index],
                [section]: action.data
            }
        }
    } else if (!value && !section) {
        newState = {
            ...state,
            [index]: action.data
        }
    }

    return newState
}

export function executeCallback(stateResult, action, reducerName) {
    if (action.callback
        && ((typeof(action.callback) ===  'function') || (typeof(action.callback.success) ===  'function'))) {
        if (typeof(action.callback) ===  'function') setTimeout(() => {action.callback(reducerName, stateResult, action)}, 200)
        else setTimeout(() => {action.callback.success(reducerName, stateResult, action)}, 200)
    }

    return stateResult
}